<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16">
      <h2 class="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center">Rastreo GPS de Enfermeros</h2>

      <!-- Selector de enfermeros -->
      <div class="mb-6">
        <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          Seleccionar Enfermero:
        </label>
        <select 
          v-model="enfermeroSeleccionado" 
          @change="mostrarMapa()" 
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
        >
          <option value="">Todos los Enfermeros</option>
          <option v-for="enfermero in enfermeros" :key="enfermero.id" :value="enfermero.id">
            {{ enfermero.nombre }}
          </option>
        </select>
      </div>

      <!-- Contenedor del Mapa -->
      <div class="relative overflow-hidden rounded-lg shadow-md">
        <div id="map" class="w-full h-[600px]"></div>
      </div>

      <!-- Leyenda -->
      <div class="mt-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
        <h3 class="text-sm font-medium text-gray-900 dark:text-white mb-2">Leyenda:</h3>
        <div class="flex items-center gap-4">
          <div class="flex items-center">
            <img src="https://img.icons8.com/ultraviolet/40/000000/car.png" alt="Enfermero" class="w-6 h-6 mr-2"/>
            <span class="text-sm text-gray-700 dark:text-gray-300">Ubicación del Enfermero</span>
          </div>
          <div class="flex items-center">
            <div class="w-4 h-1 bg-blue-500 mr-2"></div>
            <span class="text-sm text-gray-700 dark:text-gray-300">Ruta al Destino</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { collection, onSnapshot } from "firebase/firestore";
import { db } from '../../firebase';

function loadGoogleMapsApi() {
  return new Promise((resolve, reject) => {
    if (typeof window.google !== 'undefined') {
      resolve(window.google);
    } else {
      const script = document.createElement('script');
      script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAEFanXfud50zI4ca2OdCxBcdouRlod3mo";
      script.async = true;
      script.onload = () => resolve(window.google);
      script.onerror = reject;
      document.head.appendChild(script);
    }
  });
}

export default {
  data() {
    return {
      mapa: null,
      enfermeros: [],
      enfermerosMarkers: {},
      directionsService: null,
      directionsRenderer: null,
      enfermeroSeleccionado: '',
      iniciado: false,
      enfermerosMarkersArray:[]
    };
  },
  methods: {
    async cargarPosicionesEnfermeros() {
      onSnapshot(collection(db, "enfermeros"), snapshot => {
        
        this.enfermeros = snapshot.docs
          .filter(doc => doc.data().activo) // Solo enfermeros activos
          .map(doc => ({
            id: doc.id,
            nombre: doc.data().nombre || "Desconocido",
            ubicacionActual: doc.data().ubicacionActual || null,
            destino: doc.data().destino || null,
          }));
          this.mostrarMapa()
      });
    },
    async mostrarMapa() {
      const google = await loadGoogleMapsApi();
      const centro = { lat: 18.2208, lng: -66.5901 };

      if(!this.iniciado){

        this.mapa = new google.maps.Map(document.getElementById('map'), {
          center: centro,
          zoom: 10,
        });
        this.iniciado = true
      }
      if (!this.enfermerosMarkersArray) {
    this.enfermerosMarkersArray = [];
  }

  // Limpiar todos los marcadores previos
  this.enfermerosMarkersArray.forEach(marker => {
    marker.setVisible(false);
  });
      // Limpiar marcadores previos
      // for (const key in this.enfermerosMarkers) {
      //   console.log(this.enfermerosMarkers[key])
      //   this.enfermerosMarkers[key].marker.setMap(null);
      // }
      if (!this.enfermerosMarkersArray) {
    this.enfermerosMarkersArray = [];
  }

  // Limpiar todos los marcadores previos
  this.enfermerosMarkersArray.forEach(marker => {
    marker.setMap(null); // Remover marcador del mapa
  });
  this.enfermerosMarkers = {};
  this.enfermerosMarkersArray = [];

      // Obtener enfermeros a mostrar
      const enfermerosAMostrar = this.enfermeroSeleccionado
        ? this.enfermeros.filter(e => e.id === this.enfermeroSeleccionado)
        : this.enfermeros;

      // Mostrar marcadores y rutas
      enfermerosAMostrar.forEach(enfermero => {
        const posicion = enfermero.ubicacionActual;
        if (posicion) {
          const marker = new google.maps.Marker({
            position: { lat: posicion.lat, lng: posicion.lng },
            map: this.mapa,
            title: enfermero.nombre,
            icon: {
              url: "https://img.icons8.com/ultraviolet/40/000000/car.png",
              scaledSize: new google.maps.Size(40, 40),
            },
            label: { text: enfermero.nombre, color: 'black', fontWeight: 'bold' }
          });
          this.enfermerosMarkers[enfermero.id] = { marker };
          this.enfermerosMarkersArray.push(marker);

          if (enfermero.destino) {
            this.mostrarRutaEnfermero(posicion, enfermero.destino);
          }
        }
      });
    },

    // async mostrarMapa() {
    //   const google = await loadGoogleMapsApi();
    //   const centro = { lat: 18.2208, lng: -66.5901 };

    //   this.mapa = new google.maps.Map(document.getElementById('map'), {
    //     center: centro,
    //     zoom: 10,
    //   });

    //   this.enfermeros.forEach(enfermero => {
    //     const posicion = enfermero.ubicacionActual;
    //     if (posicion) {
    //       if (this.enfermerosMarkers[enfermero.id]) {
    //         this.enfermerosMarkers[enfermero.id].marker.setPosition(new google.maps.LatLng(posicion.lat, posicion.lng));
    //       } else {
    //         const marker = new google.maps.Marker({
    //           position: { lat: posicion.lat, lng: posicion.lng },
    //           map: this.mapa,
    //           title: enfermero.nombre,
    //           icon: {
    //             url: "https://img.icons8.com/ultraviolet/40/000000/car.png",
    //             scaledSize: new google.maps.Size(40, 40),
    //           },
    //           label: { text: enfermero.nombre, color: 'black', fontWeight: 'bold' }
    //         });
    //         this.enfermerosMarkers[enfermero.id] = { marker };
    //       }

    //       if (enfermero.destino) {
    //         this.mostrarRutaEnfermero(posicion, enfermero.destino);
    //       }
    //     }
    //   });
    // },

    mostrarRutaEnfermero(origen, destino) {
      const google = window.google;
      if (!this.directionsService) {
        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer({
          map: this.mapa,
          suppressMarkers: true,
        });
      }

      this.directionsService.route(
        {
          origin: origen,
          destination: destino,
          travelMode: google.maps.TravelMode.DRIVING,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.directionsRenderer.setDirections(result);
          } else {
            console.error("Error al calcular la ruta:", status);
          }
        }
      );
    },
  },
  mounted() {
    this.cargarPosicionesEnfermeros();

  }
};
</script>

<style scoped>
/* Eliminamos los estilos ya que usamos Tailwind */
</style>
